import { useState } from 'react';
import styles from './Select.module.scss';

export const Select = ({ value, onChange, options, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find(option => option.value === value);

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  const handleOptionClick = option => {
    const syntheticEvent = {
      target: { value: option.value },
    };
    onChange?.(syntheticEvent);
    setIsOpen(false);
  };

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={`${styles.control} ${isOpen ? styles.controlOpen : ''}`}
        onClick={handleToggle}
      >
        <span
          className={
            selectedOption ? styles.value : `${styles.value} ${styles.placeholder}`
          }
        >
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className={styles.menu}>
          {options.map(option => (
            <div
              key={option.value}
              className={`${styles.option} ${
                option.value === value ? styles.optionActive : ''
              }`}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


